// extracted by mini-css-extract-plugin
export default {"container":"phone_container__9H59R","smsP":"phone_smsP__LsQSb"};